var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7116 1.53341C13.5502 0.933882 13.0774 0.461176 12.4777 0.299765C11.3822 0 6.99997 0 6.99997 0C6.99997 0 2.61778 0 1.52223 0.288235C0.934098 0.449647 0.449751 0.933882 0.288302 1.53341C0 2.62871 0 4.9 0 4.9C0 4.9 0 7.18282 0.288302 8.26659C0.449751 8.86612 0.922566 9.33882 1.52223 9.50023C2.62931 9.8 6.99997 9.8 6.99997 9.8C6.99997 9.8 11.3822 9.8 12.4777 9.51176C13.0774 9.35035 13.5502 8.87765 13.7116 8.27812C13.9999 7.18282 13.9999 4.91153 13.9999 4.91153C13.9999 4.91153 14.0115 2.62871 13.7116 1.53341Z",
    fill: "#FF4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 4.9L5.60001 2.8V7L9.33334 4.9Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bff7af93124e9084de18b92d2e9f01ec.svg";
export { ForwardRef as ReactComponent };